import BaseView from '../core/baseView';
import RemotePreloaderView from '../validation/remotePreloaderView';
import { get as t } from '../../home24/core/translation';
import * as config from '../../home24/core/config';

export default BaseView.extend({
  initialize() {
    const self = this;
    const $input = self.$el;
    if (self.$el.length === 1) {
      $input.rules('add', {
        required: true,
        remote: {
          url: config.get('emailValidation.url'),
          timeout: config.get('emailValidation.timeout'),
          method: 'POST',
          contentType: 'application/json',
          beforeSend(jqXHR, options) {
            self.preloader =
              self.preloader || new RemotePreloaderView({ el: $input });
            self.preloader.show();
            options['data'] = JSON.stringify({ email: $input.val() });
          },
          complete() {
            self.preloader.hide();
          }
        },
        messages: {
          remote: t('ui.input.validation.email.remote.error')
        }
      });
    } else {
      self.destroy();
    }
  },
  destroy: function() {
    if (this.$el.length === 1) {
      this.$clone.remove();
    }

    this.undelegateEvents();
    this.$el.removeData().unbind();
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/remoteEmailValidation.js
 **/